// removed by extract-text-webpack-plugin
module.exports = {"base":"UnitsCarousel_base--NBG6_"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/UnitsCarousel/UnitsCarousel.scss
// module id = 472
// module chunks = 11 12